var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHide = function SvgHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.176 2.176a.6.6 0 0 0-.058.781l.058.067 3.227 3.228a7.989 7.989 0 0 0-3.164 4.6.6.6 0 1 0 1.164.29 6.792 6.792 0 0 1 2.864-4.026l1.448 1.447a3.2 3.2 0 0 0 4.525 4.525l4.736 4.736a.6.6 0 0 0 .906-.781l-.058-.067-4.89-4.892-5.559-5.558.001-.001-.907-.905-3.445-3.444a.6.6 0 0 0-.848 0ZM10 4.8c-.8 0-1.577.118-2.311.34l.99.989a6.803 6.803 0 0 1 7.92 5.018.6.6 0 0 0 1.163-.291A8.003 8.003 0 0 0 10 4.8Zm.156 2.807 3.04 3.041a3.202 3.202 0 0 0-3.04-3.04Z",
    fill: "#666"
  })));
};
export default SvgHide;